var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgComment = function SvgComment(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.9 14C4.71435 14 4.5363 13.9263 4.40503 13.795C4.27375 13.6637 4.2 13.4857 4.2 13.3V11.2H1.4C1.0287 11.2 0.672601 11.0525 0.41005 10.7899C0.1475 10.5274 0 10.1713 0 9.8V1.4C0 1.0287 0.1475 0.672601 0.41005 0.41005C0.672601 0.1475 1.0287 0 1.4 0H12.6C12.9713 0 13.3274 0.1475 13.5899 0.41005C13.8525 0.672601 14 1.0287 14 1.4V9.8C14 10.1713 13.8525 10.5274 13.5899 10.7899C13.3274 11.0525 12.9713 11.2 12.6 11.2H8.33L5.74 13.797C5.6 13.93 5.425 14 5.25 14H4.9ZM5.6 9.8V11.956L7.756 9.8H12.6V1.4H1.4V9.8H5.6ZM9.8 8.4H4.2V7.7C4.2 6.769 6.069 6.3 7 6.3C7.931 6.3 9.8 6.769 9.8 7.7V8.4ZM7 2.8C7.3713 2.8 7.7274 2.9475 7.98995 3.21005C8.2525 3.4726 8.4 3.8287 8.4 4.2C8.4 4.5713 8.2525 4.9274 7.98995 5.18995C7.7274 5.4525 7.3713 5.6 7 5.6C6.6287 5.6 6.2726 5.4525 6.01005 5.18995C5.7475 4.9274 5.6 4.5713 5.6 4.2C5.6 3.8287 5.7475 3.4726 6.01005 3.21005C6.2726 2.9475 6.6287 2.8 7 2.8Z"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgComment, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/comment.22e5986f.svg";
export { ForwardRef as ReactComponent };